import SpecialBogo from 'src/dispensary/specials/offer';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialBogo, CoreMenuLayout);
